<template>
    <div>
        <!-- <section id="intro-banner" class="about-us-section">
            <img
                src="assets/images/navidad/adornos.png"
                alt="Navidad"
                class="float-right img-fluid"
            />
        </section> -->
        <section id="banner2" class="">
            <banner :sliders="config" />
        </section>

        <section id="buscar-vehiculo" class="white-bg">
            <div class="container">
                <filtroCarros />
            </div>
        </section>
        <section id="catalogo" class="section-padding dark-bg">
            <div class="container">
                <carrosRecientes :carros="inventario" />
                <b-row class="justify-content-md-center mt-3">
                    <b-col md="auto">
                        <a
                            href="/compra_de_usados"
                            aria-label="Ver Catálogo"
                            role="button"
                            class="btn btn-sm uppercase"
                            >Ver Catálogo
                        </a>
                    </b-col>
                </b-row>
            </div>
        </section>
        <section id="how-work" class="section-padding">
            <div class="container">
                <div class="buy-sell-car">
                    <div class="act-car-img">
                        <img
                            src="assets/images/slider/mb_gle.webp"
                            class="img-fluid"
                            alt="Compra o Vende tu usado"
                        />
                    </div>
                    <div class="new-car act-car">
                        <h4>¿Quieres comprar?</h4>
                        <p>
                            <a
                                href="/compra_de_usados"
                                class="btn dark btn-sm uppercase"
                                aria-label="Ver Catálogo"
                                >VER CATÁLOGO
                            </a>
                        </p>
                    </div>
                    <div class="old-car act-car">
                        <h4>¿Quieres vender?</h4>
                        <p>
                            <a
                                href="/vender?step=1#services"
                                class="btn btn-sm uppercase"
                                aria-label="Cotizar Usado"
                                >COTIZAR USADO
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section id="como-trabajamos" class="section-padding d-none d-sm-block">
            <div class="container">
                <div class="heading-3 text-center">
                    <!-- <h2>Cómo funciona</h2> -->
                </div>
                <div class="row">
                    <div class="col-md-3 col-sm-6">
                        <div class="work-steps">
                            <div class="icon-wrap">
                                <img
                                    src="assets/images/icon-80x80-4.png"
                                    alt="icono-vehiculos-inspeccionados"
                                    width="80"
                                    height="80"
                                />
                            </div>
                            <h5 class="text-dark">Vehículos inspeccionados</h5>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="work-steps">
                            <div class="icon-wrap">
                                <img
                                    src="assets/images/icon-80x80-2.png"
                                    alt="icon-precios-justos"
                                    width="80"
                                    height="80"
                                />
                            </div>
                            <h5 class="text-dark">Precios justos</h5>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="work-steps">
                            <div class="icon-wrap">
                                <img
                                    src="assets/images/icon-80x80.png"
                                    alt="icon-tramites"
                                    width="80"
                                    height="80"
                                />
                            </div>
                            <h5 class="text-dark">Tramitamos el traspaso</h5>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="work-steps">
                            <div class="icon-wrap">
                                <img
                                    src="assets/images/icon-80x80-3.png"
                                    alt="icon-pagos"
                                    width="80"
                                    height="80"
                                />
                            </div>
                            <h5 class="text-dark">Pago de forma segura</h5>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-padding gray-bg" id="consignar">
            <div class="container">
                <div class="section-header">
                    <h2>
                        Permuta o Vende
                        <span>Tu Vehículo Usado</span>
                    </h2>
                    <h3>
                        <span>
                            Nos encargamos de la venta de tu vehículo desde el
                            principio hasta el final, maximizando el valor
                            comercial del vehículo, garantizando el pago y el
                            traspaso.
                        </span>
                    </h3>
                    <div class="row">
                        <div class="col-md-8 mt-5">
                            <h4>
                                <span>
                                    <i
                                        class="fa fa-check"
                                        aria-hidden="true"
                                    ></i>
                                    Diligencia los datos de tu vehículo en unos
                                    simples clics.
                                </span>
                                <hr />
                                <span>
                                    <i
                                        class="fa fa-check"
                                        aria-hidden="true"
                                    ></i>
                                    Agenda una inspección a domicilio o en
                                    nuestra sede.
                                </span>
                                <hr />
                                <span>
                                    <i
                                        class="fa fa-check"
                                        aria-hidden="true"
                                    ></i>
                                    Vende tu vehículo al mejor precio del
                                    mercado.
                                </span>
                            </h4>
                            <b-row>
                                <div class="col-md-6 text-center ">
                                    <div class="form-group">
                                        <a
                                            href="/vender?step=1#services"
                                            class="btn btn-block text-uppercase mt-5"
                                            aria-label="Cotiza tu vehiculo"
                                        >
                                            Cotiza tu vehículo
                                        </a>
                                    </div>
                                </div>
                            </b-row>
                        </div>
                        <div class="col-md-4">
                            <div class="row mt-3">
                                <div class="col-md-12 text-center ">
                                    <img
                                        src="/assets/images/slider/carros.webp"
                                        alt="Carro-Consignacion"
                                        class="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="porque-elejirnos" class="vc_row">
            <div class=" col-md-6 vc_col section-padding dark-bg ">
                <div class="fact_m white-text">
                    <h2>Porqué <span>Elegirnos</span></h2>
                    <ul>
                        <li>
                            <i class="fa fa-calendar" aria-hidden="true"></i>
                            <h2>10+</h2>
                            <p>Años en el Mercado</p>
                        </li>

                        <li>
                            <i class="fa fa-car" aria-hidden="true"></i>
                            <h2>2000+</h2>
                            <p>Vehículos Vendidos</p>
                        </li>

                        <li>
                            <i class="fa fa-car" aria-hidden="true"></i>
                            <h2>3000+</h2>
                            <p>Consignaciones</p>
                        </li>

                        <li>
                            <i class="fa fa-users" aria-hidden="true"></i>
                            <h2>3500+</h2>
                            <p>Clientes Satisfechos</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class=" col-md-6 vc_col section-padding">
                <div class="facts_section_bg"></div>
            </div>
        </section>

        <!--  <section class="section-padding gray-bg">
            <carrosVendidos :carros="inventario_vendidos" />
        </section> -->
    </div>
</template>

<script>
import banner from "./frontBanner";
import nosotros from "./frontNosotros";
import marcasPopulares from "./frontMarcasPopulares";
import filtroCarros from "./frontFiltroCarros";
import carrosRecientes from "./frontCarrosRecientes";
import carrosVendidos from "./frontVendidos";

export default {
    props: ["inventario", "inventario_vendidos", "config"],
    components: {
        banner,
        nosotros,
        carrosVendidos,
        filtroCarros,
        carrosRecientes,
        marcasPopulares
    }
};
</script>

<style lang="scss">
section#intro-banner {
    background: url(/images/banner-gray.jpg) no-repeat bottom center/cover;
    padding: 0;
}
.act-car-img {
    top: -80px !important;
}

/* .act-car {
    padding: 20px 140px 20px 120px !important;
} */
.new-car {
    //border-radius: 0 0 0 100px !important;
    border-radius: 20px !important;
}
.old-car {
    // border-radius: 0 0 100px 0 !important;
    border-radius: 20px !important;
}

.new-car.act-car:hover {
    background: #222222;
}
.old-car.act-car:hover {
    background: #fa2837;
}
.act-car {
    padding: 20px 50px 20px 50px !important;
}
.icon-wrap {
    background: #eaeaea;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    text-align: center;
    line-height: 110px;
    margin: 0 auto 20px;
}
</style>
